Ext.define('SA.ProjectView', {
    alias: 'widget.project-view',
    extend: 'SA.view.SimpleContainer',

    statics: {
        createHidden(item) {
            return Ext.widget({xtype: 'project-view', item, hidden: true, renderTo: Ext.getBody()});
        },

        createOffScreen(item) {
            return Ext.widget({xtype: 'project-view', item, autoShow: true, renderTo: Ext.getBody(), cls: 'sa-project-view-off-screen'});
        },

        getSpace() {
            var width = window.innerWidth - SA.ViewChooser.getWidth() - SA.Sidebar.getWidth(),
                height = window.innerHeight - SA.PageHeader.getHeight() - SA.ProjectViewToolbar.getHeight();

            return {width, height};
        },

        show(projectView) {
            this.projectView?.hide();

            this.projectView = projectView;
            this.projectView.removeCls('sa-project-view-off-screen');
            this.projectView.updateSize();
            this.projectView.show();

            SA.ProjectViewContainmentObserver.setListener(() => this.projectView.updateSize());
        }
    },

    baseCls: 'sa-project-view',
    hideMode: 'asclass',

    initComponent() {
        this.item = this.add(this.item);

        this.updateSize();

        this.callParent();
    },

    getChildItems() {
        var items = this.callParent(),
            floatingItems = this.floatingItems;

        if (floatingItems) {
            items.push.apply(items, floatingItems);
        }

        return items;
    },

    getItem() {
        return this.item;
    },

    setFloatingItems(items) {
        this.floatingItems = items.map(cfg => {
            return Ext.widget(Object.assign({
                getRefOwner: () => this,
                renderTo: this.el
            }, cfg));
        });
    },

    updateSize() {
        var el = this.el,
            {width, height} = SA.ProjectView.getSpace(),
            oldWidth = this.width,
            oldHeight = this.height;

        if (el) {
            el.setStyle('left', SA.Sidebar.getWidth() + 'px');
        }

        if (oldWidth === width && oldHeight === height) {
            return;
        }

        this.width = width;
        this.height = height;

        if (el) {
            el.setSize(width, height);
        }

        this.item.setSize(width, height);

        this.fireEvent('resize', this, width, height, oldWidth, oldHeight);
    },

    wrapPrimaryEl(dom) {
        this.callParent([dom]);

        this.el.visibilityCls = 'sa-project-view-hidden';
    }
});